import React from 'react'
import styled from 'styled-components'

import PropTypes from 'prop-types'
import classNames from 'classnames'
import Typography from '@material-ui/core/Typography'

import { withStyles } from '@material-ui/core/styles'
import TableBody from 'components/molecules/TableBody'
import TableHeader from 'components/molecules/TableHeader'
import TablePreloader from 'components/atoms/TablePreloader'
import BlueCheckbox from 'components/atoms/BlueCheckbox'

const styles = theme => ({
  root: {
    animation: 'fadeIn .3s ease',
    marginTop: theme.spacing(1),
    minHeight: 600,
  },
  body: {
    transition: 'opacity .1s ease .1s',
  },
  loading: {
    opacity: 0.5,
    transition: 'opacity .1s ease',
  },
})

const StyledCheckbox = styled(BlueCheckbox)`
  margin-right: 20px;
`

const CheckboxContainer = styled.div`
  display: flex;
  margin-top: 20px;
`

const DataTable = ({
  classes,
  columns,
  orderBy,
  orderAsc,
  className,
  onRowClick,
  headerProps,
  onSortClick,
  dataProvider,
  handleShare,
  rowComponent,
  tableLoading,
  onSelectableClick,
  rowComponentProps,
  hasArchivedCheckbox,
  handleArchivedToggle,
  isArchived,
  ...bodyProps
}) => {
  const SHOW_ARCHIVED_TRAPS = 'SHOW ARCHIVED TRAPS'

  return (
    <div className={classNames(classes.root, className)}>
      <TableHeader
        columns={columns}
        ascending={orderAsc}
        selectedColumn={orderBy}
        onSortClick={onSortClick}
        disabled={!dataProvider || !Object.keys(dataProvider).length}
        {...headerProps}
      />
      {dataProvider ? (
        <React.Fragment>
          <div
            className={classNames(classes.body, tableLoading && classes.loading)}>
            <TableBody
              handleShare={handleShare}
              columns={columns}
              onRowClick={onRowClick}
              dataProvider={dataProvider}
              rowComponent={rowComponent}
              onItemSelect={onSelectableClick}
              rowComponentProps={rowComponentProps}
              {...bodyProps}
            />
          </div>
          {hasArchivedCheckbox && 
          <CheckboxContainer>
            <StyledCheckbox
              checked={isArchived}
              onChange={handleArchivedToggle}
            />   
            <Typography>
              {SHOW_ARCHIVED_TRAPS}            
            </Typography>
          </CheckboxContainer>
          }
        </React.Fragment>
      ) : (
        <TablePreloader />
      )}
    </div>
  ) 
}

DataTable.propTypes = {
  columns: PropTypes.array,
  orderAsc: PropTypes.bool,
  classes: PropTypes.object,
  orderBy: PropTypes.string,
  handleShare: PropTypes.func,
  onRowClick: PropTypes.func,
  className: PropTypes.string,
  onSortClick: PropTypes.func,
  rowComponent: PropTypes.object,
  tableLoading: PropTypes.bool,
  headerProps: PropTypes.object,
  dataProvider: PropTypes.object,
  onSelectableClick: PropTypes.func,
  rowComponentProps: PropTypes.object,
  hasArchivedCheckbox: PropTypes.bool,
  handleArchivedToggle: PropTypes.func,
  isArchived: PropTypes.bool,
}

export default withStyles(styles)(DataTable)



// WEBPACK FOOTER //
// ./src/components/organisms/DataTable/DataTable.js